<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form #form="ngForm" class="form-validate">
      <div class="row mb-3">
        <label class="col-form-label col-auto">
          <i class="bi bi-search me-1"></i>ค้นหาเพื่อลงทะเบียนสิทธิว่าง UCEP
        </label>
      </div>
      <hr>
      <div class="row mb-3">
        <label for="pid" class="col-form-label col-xl-2">เลขประจำตัวประชาชน</label>
        <div class="col-xl-3">
          <input id="pid" class="form-control" name="pid" [(ngModel)]="param.pid">
        </div>
        <label for="status" class="col-form-label col-xl-1">สถานะ</label>
        <div class="col-xl-3">
          <select id="status" class="form-select" name="status" [(ngModel)]="param.status">
            <option [value]="0">ทั้งหมด</option>
            <option selected [value]="1">รอลงทะเบียน</option>
            <option [value]="2">ลงทะเบียนแล้ว</option>
            <option [value]="3">ลงทะเบียนไม่ได้</option>
          </select>
        </div>

      </div>

      <div class="row mb-3">
        <label for="fname" class="col-form-label col-xl-2">ชื่อ</label>
        <div class="col-xl-3">
          <input id="fname" class="form-control" name="fname" [(ngModel)]="param.fname">
        </div>
        <label for="lname" class="col-form-label col-xl-1">นามสกุล</label>
        <div class="col-xl-3">
          <input id="lname" class="form-control" name="lname" [(ngModel)]="param.lname">
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-xl-12 text-center align-content-center justify-content-center">
          <button type="submit" class="btn btn-primary me-3" (click)="search()">
            <i class="bi bi-search me-1"></i>ค้นหา
          </button>
          <button type="submit" class="btn btn-outline-secondary me-3" (click)="clear()">
            <i class="bi bi-eraser-fill me-2"></i>เคลียร์ข้อมูล
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="form-check mx-2">
      <input class="form-check-input" type="checkbox" value="" id="check-all" [checked]="checkedAll"
             (change)="checkAll($event)">
      <label class="form-check-label" for="check-all">
        เลือกทั้งหมด
      </label>
    </div>
    <div class="table-responsive mt-4">
      <table class="table table-bordered sticky-table" style="width: 100%;">
        <thead class="thead-light text-center">
        <tr>
          <th rowspan="2" class="sticky-col sticky-col-1 head-color">เลือก</th>
          <th rowspan="2" class="sticky-col sticky-col-2 head-color">ลำดับ</th>
          <th rowspan="2" class="head-color">CODE</th>
          <th rowspan="2" class="head-color">PA CODE</th>
          <th rowspan="2" class="sticky-col sticky-col-5 head-color">เลขประจำตัวประชาชน</th>
          <th nowrap rowspan="2" class="head-color">ชื่อผู้ป่วย</th>
          <th nowrap rowspan="2" class="head-color">นามสกุลผู้ป่วย</th>
          <th nowrap rowspan="2" class="head-color">วันเดือนปีเกิด</th>
          <th rowspan="2" class="head-color">เพศ</th>
          <th nowrap rowspan="2" class="head-color">วันที่สร้างรายการ</th>
          <th nowrap rowspan="2" class="sticky-col sticky-col-11 head-color">วันที่รับไว้รักษา</th>
          <th rowspan="2" class="head-color">หมายเหตุ</th>
          <th rowspan="2" class="head-color">ติดต่อ</th>
          <th class="head-color" colspan="6">เครือข่ายหน่วยบริการ</th>
          <th nowrap rowspan="2" style="padding-inline: 48px" class="head-color head-color">วันที่เปลี่ยนแปลงสิทธิ (TransDate)</th>
          <th nowrap rowspan="2" style="padding-inline: 31px" class="head-color head-color">วันที่เริ่มใช้สิทธิ (StartDate)</th>
          <th nowrap rowspan="2" style="padding-inline: 48px" class="head-color head-color">สิทธิหลัก</th>
          <th nowrap rowspan="2" style="padding-inline: 48px" class="head-color head-color">สิทธิย่อย</th>
          <th nowrap rowspan="2" style="padding-inline: 48px" class="head-color head-color">วันหมดสิทธิ</th>
          <th rowspan="2" class="head-color">สาเหตุกรณีที่ไม่สามารถลงทะบียนได้</th>
          <th rowspan="2" class="head-color">จัดการ</th>
        </tr>
        <tr>
          <th nowrap class="head-color head-color"></th>
          <th nowrap class="head-color head-color">จังหวัดที่ลงทะเบียน</th>
          <th nowrap class="head-color head-color">หน่วยบริการปฐมภูมิ</th>
          <th nowrap class="head-color head-color">หน่วยบริการประจำ</th>
          <th nowrap class="head-color head-color">หน่วยบริการที่รับการส่งต่อ</th>
          <th nowrap class="head-color head-color">เจ้าของเครือข่ายพิเศษ</th>
        </tr>
        </thead>
        <tbody>
          @if (!pageData?.content.length) {
            <tr>
              <td colspan="26">
                <i class="bi bi-inbox"></i> ไม่พบข้อมูล
              </td>
            </tr>
          }
          @for (item of pageData?.content; let i = $index; track item) {
            <tr [class.row-disabled]="item.disabled" [class.row-processed]="item.processStatus === 'Y'"
            >
              <td class="sticky-col sticky-col-1 bg-white">
                <div class="form-check">
                  <input *ngIf="!item.disabled && item.processStatus != 'Y' " class="form-check-input" type="checkbox" [checked]="item['checked']"
                         (change)="checked(item,$event)">
                </div>
              </td>
              <td nowrap
                  class="text-center sticky-col sticky-col-2 bg-white">{{ (pageData.size * pageData.number) + (i + 1) }}
              </td>
              <td>{{ item?.code }}</td>
              <td>{{ item?.paCode }}</td>
              <td class="sticky-col sticky-col-5 bg-white">{{ item?.pid }}</td>
              <td>{{ item?.personalData?.firstName }}</td>
              <td>{{ item?.personalData?.lastName }}</td>
              <td>{{ item?.personalData?.parseBirthDate | thaidatetime: {showTime: false} }}</td>
              <td>{{ item?.personalData?.sex == 'MALE' ? 'ชาย' : item?.personalData?.sex == 'FEMALE' ? 'หญิง' : '-' }}</td>
              <td>{{ item?.createdDate | thaidatetime:{showTime: false} }}</td>
              <td class="sticky-col sticky-col-11 bg-white">{{ item?.admissionDate | thaidatetime:{showTime: false} }}
              </td>
              <td>{{ item?.remark }}</td>
              <td>{{ item?.contact }}</td>
              <td nowrap class="text-center align-content-center justify-content-center">
                <button [disabled]="item.disabled" (click)="selectMastercup(item)" type="button"
                        class="btn btn-outline-primary">
                  เลือก
                </button>
                <gt-error *ngIf="item['checked'] && !item?.mastercup" field="mastercup"/>
              </td>
              <td>{{ item?.mastercup?.province?.name }}</td>
              <td>{{ item?.mastercup?.hospSub?.displayName }}</td>
              <td>{{ item?.mastercup?.hospMainOp?.displayName }}</td>
              <td>{{ item?.mastercup?.hospMain?.displayName }}</td>
              <td>{{ item?.mastercup?.hospMainHostDisplayName || item?.mastercup?.hmainHost || '-' }}</td>
              <td nowrap style="display: flex;">
                <span style="width: 136px"><gt-ng-datepicker [(ngModel)]="item['date']"
                                                             [name]="i+'date'"
                                                             [disabled]="true"
                                                             (ngModelChange)="changeDate(item,$event)"></gt-ng-datepicker></span>
                <span style="margin-left: 10px "><ngb-timepicker [name]="i+'time'"
                                                                 [(ngModel)]="item['time']"
                                                                 [disabled]="true"
                                                                 [spinners]="false"
                                                                 (ngModelChange)="changeTime(item,$event)"/></span>
                <gt-error *ngIf="item['checked'] && !item?.transDate" field="transDate"/>
              </td>
              <td nowrap>
                <gt-ng-datepicker style="width: 100%" [(ngModel)]="item.startDate" [disabled]="true"
                                  name="transDate"></gt-ng-datepicker>
                <gt-error *ngIf="item['checked'] && !item?.startDate" field="startDate"/>
              </td>
              <td nowrap>
                <app-select-inscl-expiry-right [id]="'mainInscl-' + i"
                                               [name]="'mainInscl-' + i"
                                               required
                                               [disabled]="item.disabled"
                                               [birthDate]="item?.personalData?.parseBirthDate"
                                               [(ngModel)]="item.mainInscl"
                                               (selectionChange)="rightChange(item)"
                                               #mainInscl="ngModel">
                </app-select-inscl-expiry-right>
                <gt-error *ngIf="item['checked'] && !item?.mainInscl" field="mainInscl"/>
              </td>
              <td nowrap>
<!--                <ng-container *ngIf="item.disabled">-->
<!--                  <div class="form-text">-->
<!--                    @if (item?.subInscl?.inscl) {-->
<!--                      ({{ item?.subInscl?.inscl }}) {{ item?.subInscl?.insclName }}-->
<!--                    } @else if (item?.insclExpiry?.inscl?.inscl) {-->
<!--                      ({{ item?.insclExpiry?.inscl?.inscl }}) {{ item?.insclExpiry?.inscl?.insclName }}-->
<!--                    } @else {-->
<!--                      - -->
<!--                    }-->
<!--                  </div>-->
<!--                </ng-container>-->
<!--                <ng-container *ngIf="!item.disabled">-->
                  <app-select-inscl-expiry [id]="'subInscl-' + i"
                                           [name]="'subInscl-' + i"
                                           required
                                           [birthDate]="item?.personalData?.parseBirthDate"
                                           [mainInsclId]="item.mainInscl?.rightId"
                                           [(ngModel)]="item.insclExpiry"
                                           [disabled]="item.mainInscl == undefined || item.disabled"
                                           (ngModelChange)="onSubInsclChange(item?.personalData?.parseBirthDate,item,$event)"
                                           #subInscl="ngModel">
                  </app-select-inscl-expiry>
<!--                </ng-container>-->
                <gt-error *ngIf="item['checked'] && !item?.subInscl" field="subInscl"/>
              </td>
              <td nowrap>
                @if (item?.subInscl && item?.insclExpiry) {
                  @if (item?.insclExpiry?.expiryPolicy == 'NOEXP') {
                    <div class="form-text">ไม่มีวันหมดอายุ</div>
                  } @else {
                    <gt-ng-datepicker [disabled]="item['showExpDateFixed'] || item.disabled" [id]="i+''"
                                      [(ngModel)]="item.expDate"
                                      name="transDate"></gt-ng-datepicker>
                    <gt-error *ngIf="item['checked'] && item?.expDate" field="expDate"/>
                  }
                }
              </td>
              <td class="text-danger">
                <div class="validation-message" [innerHTML]="formatValidationMessage(item?.validationMessage)"></div>
              </td>
              <td class="text-center reprocess-cell">
                @if (canReprocess(item)) {
                  <button type="button"
                          class="btn btn-warning btn-sm reprocess-btn"
                          [disabled]="item['reprocessing']"
                          (click)="reProcess(item)">
                    @if (item['reprocessing']) {
                      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                      <span>Processing...</span>
                    } @else {
                      <i class="bi bi-arrow-repeat"></i>
                      <span>Re-process</span>
                    }
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="row">
        <div class="col-12">
          <ngb-pagination class="d-flex justify-content-center"
                          [maxSize]="5"
                          [rotate]="true"
                          [ellipses]="false"
                          [boundaryLinks]="true"
                          [page]="pageData?.number + 1"
                          (pageChange)="search($event-1)"
                          [pageSize]="pageData?.size"
                          [collectionSize]="pageData?.totalElements"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card-body">
  <div class="row">
    <div class="col-xl-12 text-center">
      <button type="submit" class="btn btn-success app-btn me-3"
              [disabled]="elementChecked().length==0"
              (click)="save()">ยืนยันการลงทะเบียน
      </button>
    </div>
  </div>
</div>
